import { render, staticRenderFns } from "./SideBarVS.vue?vue&type=template&id=17fc50d2&scoped=true"
import script from "./SideBarVS.vue?vue&type=script&lang=js"
export * from "./SideBarVS.vue?vue&type=script&lang=js"
import style0 from "./SideBarVS.vue?vue&type=style&index=0&id=17fc50d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc50d2",
  null
  
)

export default component.exports